import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LayoutService } from 'src/app/shared/services/layout.service';
import { IconHover } from '../../../enum/common-enum';

@Component({
  selector: 'app-refer-and-earn',
  templateUrl: './refer-and-earn.component.html',
  styleUrls: ['./refer-and-earn.component.scss']
})
export class ReferAndEarnComponent {
  currentHoverEffect = IconHover.Pink;
  constructor
  (
  public activeModal    : NgbActiveModal,
  public layoutService: LayoutService
  ){}
}
